import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/adesao'

class AdesaoApiClient {
	async buscarOrgaosAdesao(idAta) {
		return await axios.get(`${URL_PATH}/unidade-organizacional/doUsuario/${idAta}`)
	}

	async criarAdesao(objParam) {
		return await axios.post(`${URL_PATH}`, objParam)
	}

	async buscarAdesaoPorId(idAdesao) {
		return await axios.get(`${URL_PATH}/${idAdesao}`)
	}

	async editarAdesaoPorId(idAdesao, campos) {
		return await axios.put(`${URL_PATH}/${idAdesao}`, campos)
	}

	async buscarListagem({ filtro, paginacao }) {
		const path = `${URL_PATH}/todos/${filtro.idAta.value}`
		const url = SearchUrlParamBuilder.montarUrl(path, filtro, paginacao, true)
		return await axios.get(url)
	}

	async buscarItensAdesao(paginacao, idAdesao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idAdesao}/itens/disponiveis`,
			pagingAndSorting: paginacao,
		}).build()

		return await axios.get(url)
	}

	async salvarItemDisponivelQuantidade(salvarItemDisponivelQuantidadeAdesaoInput) {
		return await axios.post(
			`${URL_PATH}/${salvarItemDisponivelQuantidadeAdesaoInput.idAdesao}/itens`,
			salvarItemDisponivelQuantidadeAdesaoInput,
		)
	}

	async salvarItens(salvarItenasAdesaoInput) {
		return await axios.put(`${URL_PATH}/${salvarItenasAdesaoInput.idAdesao}/alterarItensParaEmElaboracao`)
	}

	async excluirItemAdesao(removerItensEmRascunhoPedidoInput) {
		return await axios.delete(`${URL_PATH}/${removerItensEmRascunhoPedidoInput.idAdesao}/removerItensEmRascunho`)
	}

	async excluirAdesao(removerAdesaoInput) {
		return await axios.delete(`${URL_PATH}/${removerAdesaoInput.idAdesao}`)
	}

	async buscarTipoVisualizacao(idAdesao) {
		return await axios.get(`${URL_PATH}/${idAdesao}/tipoVisualizacao`)
	}

	async recusarAdesao(objRecusaAdesao) {
		return await axios.put(`${URL_PATH}/${objRecusaAdesao.idAdesao}/recusar`, objRecusaAdesao)
	}

	async aceitarAdesao(objAceitarAdesao) {
		return await axios.put(`${URL_PATH}/${objAceitarAdesao.idAdesao}/aceitar`, objAceitarAdesao)
	}

	async buscarQuantidadeAdesoes() {
		return await axios.get(`${URL_PATH}/aguardandoAnalise`)
	}

	async buscarQuantidadeFornecedoresItens(idAdesao) {
		return await axios.get(`${URL_PATH}/${idAdesao}/buscarQtdDeItensEFornecedores`)
	}

	async buscarAdesoesPorAta({ idAta, paginacao, ...filtros }) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/porAta/${idAta}`,
			filters: filtros,
			pagingAndSorting: paginacao,
		}).build()

		return await axios.get(url)
	}

	async concluirAdesao(idAdesao) {
		return await axios.put(`${URL_PATH}/${idAdesao}/concluir`, { idAdesao: idAdesao })
	}

	async possuiItensPendentes(idAdesao) {
		return await axios.get(`${URL_PATH}/${idAdesao}/possuiItensPendentes`)
	}

	async enviarAdesaoIntegracao(idAdesao) {
		await axios.post(`${URL_PATH}/${idAdesao}/integracao/enviar`)
	}

	async visualizarProcessoDigitalAdesao(idAdesao) {
		return await axios.get(`${URL_PATH}/${idAdesao}/processo-digital`)
	}

	async baixarRelatorioPrevioAdesao(idAdesao) {
		return await axios.get(`${URL_PATH}/${idAdesao}/relatorio-previo/baixar`, {
			responseType: 'arraybuffer',
		})
	}

	async reenviarAdesaoParaDetalhamento(idAdesao) {
		return await axios.post(`${URL_PATH}/${idAdesao}/detalhamento/enviar`)
	}
}

export default new AdesaoApiClient()
